module.exports = __webpack_public_path__ + "img/delete_FILL.10f4eefb.svg";